const REGION_MATCHERS = {
  global: () => true,
  usa: (j) => regionKeys(j).includes("usa"),
  europe: (j) => regionKeys(j).includes("europe"),
  emea: (j) => regionKeys(j).includes("emea"),
  mena: (j) => regionKeys(j).includes("mena")
}

function regionKeys(job) {
  return Array.isArray(job?.region_keys) ? job.region_keys : []
}

export class JobWorldFilters {
  constructor(jobs = []) {
    this.jobs = jobs
    this.search = ""
    this.region = "global"
    this.tag = null
    // Default to the widest window so the globe shows the full 90-day feed
    // unless the user narrows it.
    this.maxAgeDays = 90
    this.listeners = new Map()
  }

  setSearch(value) {
    this.search = (value || "").trim().toLowerCase()
    this._emit()
  }

  setRegion(region) {
    this.region = region || "global"
    this._emit()
  }

  setTag(tag) {
    this.tag = tag || null
    this._emit()
  }

  // `days` is the maximum age (in days) for postings to include. Pass null
  // or 0 to disable date filtering.
  setDateRange(days) {
    const n = Number(days)
    this.maxAgeDays = Number.isFinite(n) && n > 0 ? n : null
    this._emit()
  }

  apply() {
    const matchRegion = REGION_MATCHERS[this.region] || REGION_MATCHERS.global
    const cutoffMs = this.maxAgeDays
      ? Date.now() - this.maxAgeDays * 24 * 60 * 60 * 1000
      : null
    return this.jobs.filter((j) => {
      if (!matchRegion(j)) return false
      if (this.tag && !(j.tags || []).includes(this.tag)) return false
      if (cutoffMs && j.pub_at) {
        const t = Date.parse(j.pub_at)
        if (Number.isFinite(t) && t < cutoffMs) return false
      }
      if (this.search) {
        const hay = [j.title, j.company, ...(j.tags || [])].join(" ").toLowerCase()
        if (!hay.includes(this.search)) return false
      }
      return true
    })
  }

  on(event, handler) {
    if (!this.listeners.has(event)) this.listeners.set(event, new Set())
    this.listeners.get(event).add(handler)
    return () => this.listeners.get(event).delete(handler)
  }

  _emit() {
    const results = this.apply()
    const handlers = this.listeners.get("filterschange") || []
    handlers.forEach((h) => h(results))
  }
}
